// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cd867786","977":"839d9680"}[chunkId] + ".chunk.js";
};